/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agent_Readiness_Col_ScoreInputs */

const en_directory_agent_readiness_col_score = /** @type {(inputs: Directory_Agent_Readiness_Col_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Score`)
};

const zh_directory_agent_readiness_col_score = /** @type {(inputs: Directory_Agent_Readiness_Col_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`得分`)
};

/**
* | output |
* | --- |
* | "Score" |
*
* @param {Directory_Agent_Readiness_Col_ScoreInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agent_readiness_col_score = /** @type {((inputs?: Directory_Agent_Readiness_Col_ScoreInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agent_Readiness_Col_ScoreInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agent_readiness_col_score(inputs)
	return zh_directory_agent_readiness_col_score(inputs)
});
export { directory_agent_readiness_col_score as "directory.agent_readiness.col.score" }